import React, { memo, useContext } from 'react'
import { ProductsMinor } from '@shopify/polaris-icons'
import { MCPaymentsTableContext } from '../payments-table/MCPaymentsTable.context'
import { PaymentStatus } from 'src/constants/payment/enums'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { PaymentStatusChip } from 'src/components/payment/grid/PaymentStatusChip'

const statuses = [
  {
    value: PaymentStatus.Paid,
    component: <PaymentStatusChip status={PaymentStatus.Paid} />,
  },
  {
    value: PaymentStatus.NotPaid,
    component: <PaymentStatusChip status={PaymentStatus.NotPaid} />,
  },
  {
    value: PaymentStatus.Pending,
    component: <PaymentStatusChip status={PaymentStatus.Pending} />,
  },
  {
    value: PaymentStatus.AutoRetry,
    component: <PaymentStatusChip status={PaymentStatus.AutoRetry} />,
  },
  {
    value: PaymentStatus.Failed,
    component: <PaymentStatusChip status={PaymentStatus.Failed} />,
  },
  {
    value: PaymentStatus.RequiresFunding,
    component: <PaymentStatusChip status={PaymentStatus.RequiresFunding} />,
  },
  {
    value: PaymentStatus.WaitingForFunding,
    component: <PaymentStatusChip status={PaymentStatus.WaitingForFunding} />,
  },
]

const MCPaymentStatusSelectComponent = () => {
  const { statusFilter, setStatusFilter } = useContext(MCPaymentsTableContext)

  return (
    <TableSelect<PaymentStatus>
      title="Payment Status"
      selectedValues={statusFilter}
      icon={<ProductsMinor width={20} />}
      options={statuses}
      onSelect={setStatusFilter}
    />
  )
}

export const MCPaymentStatusSelect = memo(MCPaymentStatusSelectComponent)
